<template>
  <div class="confirm-order" id="confirmOrder">
    <div class="page-header-container">
      <page-header></page-header>
    </div>
    <logo-header :title="logoTitle"></logo-header>
    <div class="page-content-container">
      <div class="order-content">
        <div class="address-desc-container">
          <span class="desc">选择收货地址</span>
          <span class="add-address-btn" @click="toAddNewAddess">新增收货地址</span>
        </div>
        <div
          class="address-list"
          :class="showMoreAddress ? '':'hide-more-address'"
          ref="addressList"
        >
          <address-card
            v-for="(address, index) in xbAddressList"
            :key="index"
            :shippingAddress="address"
            :is-small-card="true"
            @selected="onAddressSelected"
          ></address-card>
        </div>
        <div class="tip" v-show="!xbAddressList.length">暂无收货地址，请添加收货地址</div>
        <div class="show-more-address" @click="toggleAddressShow" v-show="xbAddressList.length > 4">
          <i class="icon" :class="showMoreAddress ? 'up':'down'"></i>
          <span class="desc">{{showMoreAddress ? '收起' : '显示更多地址'}}</span>
        </div>
        <div class="commodity-desc">
          <span>商品信息</span>
        </div>
        <!-- 购物车表格 -->
        <el-table class="table-container" ref="shoppingCartTable" :data="commodityList">
          <el-table-column label="商品" width="500">
            <template slot-scope="props">
              <div class="img-desc-container">
                <img
                  class="commodity-img"
                  @click="goToProduct(props.row.id)"
                  width="60"
                  height="60"
                  :src="props.row.img"
                  alt="商品图"
                />
                <p class="commodity-desc" @click="goToProduct(props.row.id)">
                  <span class="setMeal-tags" v-if="props.row.packageId">套餐</span>
                  <span>
                    {{props.row.name}}
                    <span class="localStorage-sign" v-if="props.row.localStorage">本地仓</span>
                  </span>
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="规格" prop="normDesc" align="cneter"></el-table-column>
          <el-table-column label="单价" align="cneter">
            <template slot-scope="props">
              <span>￥{{props.row.unitPrice.toFixed(2)}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="moduleStorage == 1? '数量(本地仓/总仓)':'数量'" align="cneter">
            <template slot-scope="props">
              <span>
                {{props.row.amount}}
                <span class="amount-num" v-if="moduleStorage == 1? true:false">{{`(${props.row.localStorage}/${props.row.defaultStorage})`}}</span></br>
                <span class="subtotal">{{props.row.noStock}}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="小计" align="cneter">
            <template slot-scope="props">
              <span class="subtotal">￥{{props.row.subtotal}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="isClickDelivery" class="deliver-goods">
          <span class="delivery" @click="delivery" v-if="moduleStorage == 1? true:false">
            <span class="desc">
              发货方式：
            </span>
            <span class="default"> 
              默认拆分发货，如要修改请点击选择
              <i class="el-icon-arrow-right"></i>
            </span>
          </span>
        </div>
        <!-- 可用优惠券列表 -->
        <div class="coupon-list" v-if="orderType === orderTypes.goodType">
          <span class="desc">可选优惠券：</span>
          <el-select class="gray" v-model="selectedCouponId" placeholder="请选择优惠券">
            <el-option
              v-for="(item, index) in couponList"
              :key="index"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </div>
        <!-- 积分中心 -->
        <div class="integral-thisTime" v-if="pointFlag">
          <span class="desc">本次使用</span>
          <el-input
            class="gray thisTime"
            placeholder="请输入"
            v-model="times"
            @input="inputIntegralValue(times)"
          ></el-input>
          <span class="point-deduction">
            积分抵扣
            <span class="point-deduction-amount">{{integralValue}}</span>
            元
          </span>
        </div>
        <!-- 买家留言 -->
        <div class="buyer-message">
          <span class="desc">买家留言：</span>
          <el-input
            class="message"
            type="textarea"
            placeholder="请输入内容"
            v-model="message"
            rows="5"
            maxlength="100"
            show-word-limit
          ></el-input>
        </div>
      </div>
      <div class="summary-container">
        <div class="summary">
          <div class="amount-total">
            <div class="left">
              <span class="amount">共{{goodsTotalAmount}}件商品</span>
              <span class="desc">商品合计：</span>
            </div>
            <span class="num">￥{{orderTotal}}</span>
          </div>
          <div class="promotion">
            <span class="desc">促销金额：</span>
            <span class="symble">-</span>
            <span class="num">
              ￥{{promotionPrice}}</span>
          </div>
          <div class="discount">
            <span class="desc">优惠金额：</span>
            <span class="symble">-</span>
            <span class="num">
              ￥{{selectedCouponValue}}</span>
          </div>
          <div class="discount" v-if="isSetMeal == 1?true:false">
            <span class="desc">优惠套餐：</span>
            <span class="symble">-</span>
            <span class="num">
              ￥{{setMeal}}</span>
          </div>
          <div class="freight" v-if="pointFlag">
            <span class="desc">积分：</span>
            <span class="symble">-</span>
            <span class="num">
              ￥{{integralValue}}</span>
          </div>
          <div class="freight">
            <span class="desc">运费：</span>
            <span class="additionSymble">+</span>
            <span class="num additionNum">
              ￥{{freight}}</span>
          </div>
        </div>
      </div>
      <div class="operation">
        <div class="payable-amount">
          <span class="desc">应付金额：</span>
          <span class="amount">￥{{needToPayTotal}}</span>
        </div>
        <el-button
          :disabled="!isClickDelivery"
          :loading="loading"
          class="confirm-btn w126"
          @click="toSubmitOrder"
          :class="allowToSubmitOrder ? '' : 'not-allow-submit'"
        >提交订单</el-button>
      </div>
    </div>
    <div class="page-footer-container">
      <page-footer></page-footer>
    </div>
    <el-dialog title="新增收货地址" :visible.sync="showAddressDialog" :close-on-click-modal="false">
      <el-form :model="addressForm" :rules="addressFormRules" ref="addressForm">
        <el-form-item label="收货人：" label-width="100px" prop="receiver">
          <el-input class="gray" v-model="addressForm.receiver"></el-input>
        </el-form-item>
        <el-form-item label="联系方式：" label-width="100px" prop="telephone">
          <el-input class="gray" v-model="addressForm.telephone"></el-input>
        </el-form-item>
        <el-form-item label="所在区域：" label-width="100px" prop="areaArr">
          <el-cascader v-model="addressForm.areaArr" :options="addressList" :props="cascaderProps"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址：" label-width="100px" prop="address">
          <el-input class="gray" v-model="addressForm.address"></el-input>
        </el-form-item>
        <el-form-item label label-width="100px">
          <el-checkbox v-model="addressForm.isDefault">设为默认地址</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="cancelNewAddress">取消</el-button>
        <el-button class="save-btn" @click="addNewAddress">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      class="delivery-dialog"
      title="发货提示"
      :visible.sync="showDeliveryDialog"
      :close-on-click-modal="false"
      :before-close="handleClose"
      width="600px"
    >
      <div class="delivery-title">
        <span class="mark">
          <img src="../../../assets/settlement/mark.png">
        </span>
        <span class="text">由于本地仓库存不足，以下商品将被拆分发货，若拒绝则从总仓统一发货。</span>
      </div>
      <div class="delivery-content">
        <el-table class="table-container" ref="shoppingCartTable" :data="unpackingList">
          <el-table-column label="商品" width="300">
            <template slot-scope="props">
              <div class="normDesc">{{props.row.name}}</div>
              <div class="normDesc">{{`(${props.row.normDesc})`}}</div>
            </template>
          </el-table-column>
          <el-table-column width="228">
            <template slot="header" slot-scope="scope">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAllAgree" @change="handleCheckAllAgreeChange">批量同意</el-checkbox>
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAllReject" @change="handleCheckAllRejectChange">批量拒绝</el-checkbox>
            </template>
            <template slot-scope="props">
              <el-checkbox-group v-model="props.row.radio" @change="handleCheckChange(props.row, props.row.radio)">
                <el-checkbox class="agree-checked" label="1">同意</el-checkbox>
                <el-checkbox label="0">拒绝</el-checkbox>
              </el-checkbox-group>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" width="148">
            <template slot-scope="props">
              <el-radio v-model="props.row.radio" label="1">同意</el-radio>
              <el-radio v-model="props.row.radio" label="0">拒绝</el-radio>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="cancelDelivery">取消</el-button>
        <el-button class="confirm-btn" @click="confirmDelivery">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script >
import { getXBBasicInformation } from "common/js/storage";
import PageHeader from "base/xb-base/Header";
import LogoHeader from "base/xb-base/LogoHeader";
import PageFooter from "base/xb-base/Footer";
import AddressCard from "base/xb-base/AddressCard";
import ShoppingCart from "models/xb/shopping-cart.js";
import XBUser from "models/xb/user.js";
import DBAddress from "models/db/address.js";
import ClientManageVue from "../../dbviews/client/client-manage/ClientManage.vue";
const shoppingCart = new ShoppingCart();
const xbUser = new XBUser();
const dbAddress = new DBAddress();
const XB_ADDRESS_LIST_MAX_LENGTH = 20;
const orderTypes = {
  goodType: 1,
  packageType: 2,
};
export default {
  data() {
    return {
      logoTitle: "订单确认",
      pointFlag: 0,
      pointsMax: null,
      orderTypes,
      orderType: "",
      addressList: [],
      cascaderProps: {
        value: "id",
        label: "name",
      },
      showMoreAddress: false,
      xbAddressList: [],
      // 选择的地址id
      selectedAddress: "",
      commodityList: [],
      orderTotal: 0,
      freight: 0,
      integralValue: 0, // 积分抵扣
      message: "",
      showAddressDialog: false,
      // 编辑或新增地址
      addressForm: {
        receiver: "",
        telephone: "",
        areaArr: [],
        address: "",
        isDefault: false,
      },
      addressFormRules: {
        receiver: {
          required: true,
          message: "请填写收货人名称",
          trigger: "blur",
        },
        telephone: {
          required: true,
          message: "请填写联系方式",
          trigger: "blur",
        },
        areaArr: {
          required: true,
          message: "请填写所在地区",
          trigger: "blur",
        },
        address: {
          required: true,
          message: "请填写详细地址",
          trigger: "blur",
        },
      },
      selectedCouponId: 0,
      selectedCouponValue: 0,
      promotionPrice: 0, // 促销价
      couponList: [],
      allowToSubmitOrder: true,
      showDeliveryDialog: false,
      moduleStorage: "", //1:开启；0：关闭
      needCheck: false, //控制发货方式显示隐藏
      isClickDelivery: true, //能否点击发货方式
      commodityListCopy: [],
      unpackingList: [], //拆货数组
      isSelect: 0, // 1为购买样品
      isSetMeal: 0, // 0为隐藏优惠套餐
      addressConfirm: [],
      setMeal: 0, // 优惠套餐金额
      times: "", // 本次使用积分
      loading: false,
      // 批量同意
      checkAllAgree: false,
      // 批量拒绝
      checkAllReject: false,
      isIndeterminate: false
    };
  },
  computed: {
    goodsTotalAmount() {
      let total = 0;
      this.commodityList.map((item) => {
        total += Number(item.amount);
      });
      return total;
    },
    needToPayTotal() {
      return (
        Math.floor(
          this.orderTotal * 100 -
            this.selectedCouponValue * 100 -
            this.promotionPrice * 100 -
            this.setMeal * 100 -
            this.integralValue * 100 +
            this.freight * 100
        ) / 100
      );
    },
    // setMeal() {
    // let setMeal = 0
    // let subtotal = 0
    // this.commodityList.map(i => {
    //   if (i.packageId) {
    //     subtotal += Number(i.subtotal)
    //   }
    // })
    // setMeal = (subtotal - this.orderTotal).toFixed(2)
    //   return setMeal
    // },
  },
  watch: {
    selectedAddress: {
      handler(newVal) {
        let goodsInfo = [];
        let itemIdList = [];
        this.commodityList.map((commodity) => {
          goodsInfo.push({
            itemId: commodity.skuId,
            quantity: commodity.amount,
            goodsId: commodity.id,
          });
          itemIdList.push(commodity.skuId);
        });
        let cityCode = this.addressConfirm.areaArr[1];
        let regionsCode = this.addressConfirm.areaArr[2];
        let data = {
          // addresses: newVal,
          cityCode,
          regionsCode,
          goodsInfo: goodsInfo,
          type: 1, //1、xb下单 2、db下单
          isSelect: this.isSelect,
        };
        this._getFreightWithAddress(data);
        let stockInfo = {
          regionsCode,
          itemIdList,
        };
        this._getStockInfo(stockInfo);
      },
    },
    selectedCouponId: {
      handler(newVal) {
        let selectedCoupon = this.couponList.find(
          (coupon) => coupon.value === newVal
        );
        // console.log("选中的购物券", selectedCoupon);
        const MINI_PAY_MONEY = 0.01;
        let isEffectiveOrder = this.orderTotal - selectedCoupon.faceValue >= 0;
        // console.log("是否有效", isEffectiveOrder);
        if (!isEffectiveOrder) {
          this.selectedCouponValue =
            Math.floor(this.orderTotal * 100 * 100 - MINI_PAY_MONEY * 100) /
            100;
        } else {
          this.selectedCouponValue = selectedCoupon.faceValue;
        }
        if (selectedCoupon.faceValue > 0) {
          let isFlag =
            this.orderTotal -
              this.selectedCouponValue -
              this.promotionPrice -
              this.integralValue >
            0;
          if (!isFlag) {
            this.integralValue =
              Math.floor(
                this.orderTotal * 100 -
                  this.selectedCouponValue * 100 -
                  this.promotionPrice * 100 -
                  MINI_PAY_MONEY * 100
              ) / 100;
          }
        }
      },
    },
    integralValue: {
      handler(newVal) {
        const MINI_PAY_MONEY = 0.01;
        let isEffectiveOrder =
          this.orderTotal -
            this.selectedCouponValue -
            this.promotionPrice -
            this.integralValue >
          0;
        if (!isEffectiveOrder) {
          this.integralValue =
            Math.floor(
              this.orderTotal * 100 -
                this.selectedCouponValue * 100 -
                this.promotionPrice * 100 -
                MINI_PAY_MONEY * 100
            ) / 100;
        }
      },
    },
  },
  methods: {
    toAddNewAddess() {
      this._showAddressDialog();
    },
    addAddress() {
      // 新增地址
      if (this.xbAddressList.length < XB_ADDRESS_LIST_MAX_LENGTH) {
        this._showAddressDialog();
      } else {
        this.$alert(`最多添加${XB_ADDRESS_LIST_MAX_LENGTH}个地址`, "操作提示", {
          confirmButtonText: "确定",
          type: "warning",
          center: true,
        });
      }
    },
    addNewAddress() {
      this.$refs.addressForm.validate((valid) => {
        if (valid) {
          let { receiver, telephone, areaArr, address, isDefault } =
            this.addressForm;
          let data = {
            receiveName: receiver,
            receivePhone: telephone,
            province: areaArr[0],
            city: areaArr[1],
            regions: areaArr[2],
            address: address,
            isDefault: Number(isDefault),
          };
          this._addXbShippingAddress(data);
          // 清空数据域
          this.addressForm.areaArr = [0, 0, 0];
          this.$refs.addressForm.resetFields();
          this._hideAddressDialog();
        } else {
          return false;
        }
      });
    },
    cancelNewAddress() {
      this.$refs.addressForm.resetFields();
      this._hideAddressDialog();
    },
    onAddressSelected(address) {
      if (address.isSelected) {
        // 选中新地址，将之前的地址列表全置为未选中状态
        this.xbAddressList.map((item) => {
          if (item.id === address.id) {
            item.isSelected = true;
          } else {
            item.isSelected = false;
          }
        });
        this.selectedAddress = address.id;
        this.addressConfirm = address;
      } else {
        // 取消选中
        this.xbAddressList.map((item) => {
          item.isSelected = false;
        });
      }
    },
    toggleAddressShow() {
      this.showMoreAddress = !this.showMoreAddress;
    },
    toSubmitOrder() {
      let data = {};
      // 先判断有没有选地址
      let selectedAddress = this.xbAddressList.find((item) => item.isSelected);
      if (this.unpackingList.length != 0) {
        this.unpackingList.map((val) => {
          this.commodityList.map((item) => {
            if (val.id == item.goodsId && val.skuId == item.itemId) {
              item.radio = val.radio;
            }
          });
        });
      }
      if (!selectedAddress) {
        this.$alert(`请先选择收货地址`, "操作提示", {
          confirmButtonText: "确定",
          type: "warning",
          center: true,
        });
        return;
      }
      // 判断有没有选择发货方式（如果库存关闭不执行）
      if (this.moduleStorage == 1 && this.needCheck == true) {
        // if (this.unpackingList.length == 0) {
        //   this.$alert(`请先选择发货方式`, "操作提示", {
        //     confirmButtonText: "确定",
        //     type: "warning",
        //     center: true,
        //   });
        //   return;
        // }
        for (let i = 0; i < this.unpackingList.length; i++) {
          if (this.unpackingList[i].radio.length == 0) {
            this.$alert(`请先选择发货方式`, "操作提示", {
              confirmButtonText: "确定",
              type: "warning",
              center: true,
            });
            return;
          }
        }
      }
      data.addressId = selectedAddress.id;
      data.message = this.message;
      data.isSelect = this.isSelect;
      data.points = this.integralValue * 10;
      // data.setMealNum = Number(this.$route.query.setMealNum);
      data.goodsInfo = [];
      data.setMealList = [];
      let arr = [];
      this.commodityList.map((item) => {
        let localNum = 0;
        let defaultNum = 0;
        if (item.radio[0] == "1") {
          localNum = Number(item.localStorage);
          defaultNum = Number(item.amount) - Number(item.localStorage);
        } else if (item.radio[0] == "0") {
          localNum = 0;
          defaultNum = Number(item.amount);
        } else {
          localNum = Number(item.amount);
          defaultNum = 0;
        }
        if (!item.packageId) {
          data.goodsInfo.push({
            goodsId: item.id,
            goodsName: item.name,
            itemId: item.skuId,
            itemTitle: item.normDesc,
            quantity: Number(item.amount),
            localNum: this.moduleStorage == 1 ? localNum : 0,
            defaultNum: this.moduleStorage == 1 ? defaultNum : item.amount,
          });
        } else {
          let obj = {};
          let setMealObj = {};
          obj.setMealId = item.packageId;
          obj.setMealNum = item.setMealNum;
          obj.setMealGoodsList = [];
          setMealObj.goodsId = item.id;
          setMealObj.itemId = item.skuId;
          setMealObj.quantity = Number(item.amount);
          (setMealObj.localNum = this.moduleStorage == 1 ? localNum : 0),
            (setMealObj.defaultNum =
              this.moduleStorage == 1 ? defaultNum : item.amount);
          obj.setMealGoodsList.push(setMealObj);
          arr.push(obj);
        }
      });
      // 筛选数组对象中相同id的数据
      let tempArr = [];
      let Data = [];
      for (let i = 0; i < arr.length; i++) {
        if (tempArr.indexOf(arr[i].setMealId) === -1) {
          Data.push({
            setMealId: arr[i].setMealId,
            setMealNum: arr[i].setMealNum,
            setMealGoodsList: arr[i].setMealGoodsList,
          });
          tempArr.push(arr[i].setMealId);
        } else {
          for (let j = 0; j < Data.length; j++) {
            if (Data[j].setMealId == arr[i].setMealId) {
              Data[j].setMealGoodsList.push(arr[i].setMealGoodsList[0]);
              break;
            }
          }
        }
      }
      data.setMealList = Data;
      if (this.orderType === orderTypes.goodType) {
        data.xbCouponId = this.selectedCouponId;
      }
      // else if (this.orderType === orderTypes.packageType) {
      //   data.setMealId = Number(this.$route.query.packageId);
      // }
      this.loading = true;
      this._submitOrder(data);
    },
    //获取运费
    _getFreightWithAddress(data) {
      shoppingCart.getFreightWithAddress(data).then((res) => {
        if (res.success) {
          this.freight = res.result.freight;
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    //获取库存信息
    _getStockInfo(data) {
      shoppingCart.getStockInfo(data).then((res) => {
        if (res.success) {
          res.result.map((i) => {
            this.commodityList.map((item) => {
              if (i.itemId == item.skuId) {
                if (Number(item.amount) > Number(i.localStorage)) {
                  item.tempNeedCheck = true;
                  item.localStorage = Number(i.localStorage);
                  if (
                    Number(item.amount) <
                    Number(i.localStorage) + Number(i.defaultStorage)
                  ) {
                    item.defaultStorage =
                      Number(item.amount) - Number(i.localStorage);
                  } else {
                    item.defaultStorage = Number(i.defaultStorage);
                  }
                } else {
                  item.tempNeedCheck = false;
                  item.localStorage = item.amount;
                  item.defaultStorage = 0;
                }
                if (
                  Number(item.amount) >
                  Number(i.localStorage) + Number(i.defaultStorage)
                ) {
                  item.noStock = "库存不足";
                } else {
                  item.noStock = "";
                }
                item.localStorageCopy = i.localStorage;
                item.defaultStorageCopy = i.defaultStorage;
              }
            });
            this.commodityListCopy = this.commodityList;
            if (
              this.commodityList.findIndex(
                (target) => target.noStock === "库存不足"
              ) == -1
            ) {
              this.isClickDelivery = true;
            } else {
              this.isClickDelivery = false;
            }
            if (
              this.commodityList.findIndex(
                (item) => Number(item.amount) > Number(item.localStorage)
              ) == -1
            ) {
              this.needCheck = false;
            } else {
              this.needCheck = true;
            }
          });
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    _showAddressDialog() {
      this.showAddressDialog = true;
    },
    _hideAddressDialog() {
      this.showAddressDialog = false;
    },
    _getDBAddressMock() {
      dbAddress.getDBAddressMock().then((res) => {
        // console.log('城市数据--', res);
        this.addressList = res;
      });
    },
    delivery() {
      let goodsInfo = [];
      let itemIdList = [];
      this.commodityList.map((commodity) => {
        goodsInfo.push({
          itemId: commodity.skuId,
          quantity: commodity.amount,
          goodsId: commodity.id,
        });
        itemIdList.push(commodity.skuId);
      });
      let cityCode = this.addressConfirm.areaArr[1];
      let regionsCode = this.addressConfirm.areaArr[2];
      let data = {
        // addresses: this.selectedAddress,
        cityCode,
        regionsCode,
        goodsInfo: goodsInfo,
        type: 1, //1、xb下单 2、db下单
        isSelect: this.isSelect,
      };
      let stockInfo = {
        regionsCode,
        itemIdList,
      };
      this._getFreightWithAddress(data);
      this._getStockInfo(stockInfo);
      this.showDeliveryDialog = true;
      this.unpackingList = [];
      this.commodityList.map((item) => {
        // if (item.tempNeedCheck) {
          this.unpackingList.push(item);
        // }
      });
      this.checkAllAgree = this.unpackingList.every((item) =>{return item.radio[0] == '1'})
      this.checkAllReject = this.unpackingList.every((item) =>{return item.radio[0] == '0'})
    },
    handleClose() {
      this.confirmDelivery();
    },
    cancelDelivery() {
      this.commodityList.map((v) => {
        v.radio = [];
      });
      this.showDeliveryDialog = false;
    },
    confirmDelivery() {
      if (this.unpackingList.length != 0) {
        this.unpackingList.map((val) => {
          this.commodityList.map((item) => {
            if (
              val.id == item.id &&
              val.skuId == item.skuId &&
              val.radio[0] == "0"
            ) {
              if (Number(item.amount) > Number(item.defaultStorageCopy)) {
                this.$message({
                  message: `${item.name}商品在总仓数量不足，请拆货`,
                  center: true,
                  type: "error",
                  duration: 1000,
                });
              } else {
                item.defaultStorage = item.amount;
                item.localStorage = 0;
              }
            } else if (
              val.id == item.id &&
              val.skuId == item.skuId &&
              val.radio[0] == "1"
            ) {
              this.commodityListCopy.map((v) => {
                if (v.id == item.id && v.skuId == item.skuId) {
                  if (item.tempNeedCheck) {
                    item.defaultStorage =
                      Number(v.amount) - Number(v.localStorageCopy);
                    item.localStorage = v.localStorageCopy;
                  }
                }
              });
            }
          });
        });
      }
      this.showDeliveryDialog = false;
    },
    // 提交订单
    _submitOrder(data) {
      shoppingCart.submitOrder(data).then((res) => {
        if (res.success) {
          // console.log('提交订单成功--', res.result);
          let { orderPreCode } = res.result;
          // 跳转路由
          this.$router.replace({
            path: "/confirm-pay",
            query: {
              orderPreCode,
            },
          });
          this.loading = false;
        } else {
          this.loading = false;
          // 提交订单异常
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    // 获取xb收货地址列表
    _getXbShippingAddressList() {
      xbUser.getXbShippingAddressList().then((res) => {
        if (res.success) {
          this.xbAddressList = [];
          res.result.map((item) => {
            this.xbAddressList.push({
              id: item.id,
              areaArr: [item.province, item.city, item.regions],
              receiver: item.receiveName,
              totalAddress: item.totalAddress,
              address: item.totalAddress,
              telephone: item.receivePhone,
              isDefault: Boolean(item.isDefault),
              isSelected: Boolean(item.isDefault),
            });
          });
          if (this.xbAddressList[0].isDefault) {
            this.addressConfirm = this.xbAddressList[0];
            this.selectedAddress = this.xbAddressList[0].id;
            // console.log("默认地址id", this.xbAddressList[0].id);
          }
        }
      });
    },
    _addXbShippingAddress(data) {
      xbUser.addXbShippingAddress(data).then((res) => {
        if (res.success) {
          this.$message({
            message: "新增成功",
            center: true,
            type: "success",
            duration: 1000,
          });
          this._getXbShippingAddressList();
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    _confirmOrder(data) {
      shoppingCart.confirmOrder(data).then((res) => {
        if (res.success) {
          // if (this.orderType === orderTypes.packageType) {
          // let { total, freight, goodsInfo, pointRes, setMealInfos } = res.result;
          // this.pointFlag = pointRes.pointFlag
          // this.pointsMax = pointRes.points
          // this.orderTotal = total;
          // this.promotionPrice = res.result.promotionReduce
          //   ? res.result.promotionReduce
          //   : 0;
          // this.freight = freight;
          // this.commodityList = [];
          // goodsInfo.map((item) => {
          //   let normList = JSON.parse(item.itemTitle);
          //   let normDesc = "";
          //   for (let key in normList) {
          //     normDesc += `,${normList[key]}`;
          //   }
          //   // if (item.setMealId) {
          //   //   this.isSetMeal = 1
          //   // }
          //   normDesc = normDesc.substring(1);
          //   let tempNeedCheck = false
          //   if (item.quantity > item.localStorage) {
          //     tempNeedCheck = true
          //   }
          //   let noStock = ''
          //   if (item.quantity > (item.localStorage+item.defaultStorage)) {
          //     noStock = '库存不足'
          //   }
          //   this.commodityList.push({
          //     id: item.goodsId,
          //     skuId: item.itemId,
          //     packageId: item.setMealId,
          //     img: item.goodsPic
          //       ? item.goodsPic
          //       : "http://image.8844it.com/ydb2/goodDefault.png",
          //     name: item.goodsName,
          //     normDesc,
          //     unitPrice: item.marketPrice,
          //     radio: '1',
          //     amount: item.quantity,
          //     localStorage: item.localStorage,
          //     defaultStorage: item.defaultStorage,
          //     localStorageCopy: item.localStorage,
          //     defaultStorageCopy: item.defaultStorage,
          //     tempNeedCheck: tempNeedCheck,
          //     noStock: noStock,
          //     subtotal: (
          //       Number(item.marketPrice) * Number(item.quantity)
          //     ).toFixed(2),
          //   });
          // });
          // }
          // else if (this.orderType === orderTypes.goodType) {
          let {
            total,
            freight,
            goodsInfo,
            couponRes,
            pointRes,
            setMealInfos,
            setMealReduce,
          } = res.result;
          this.setMeal = setMealReduce;
          this.pointFlag = pointRes.pointFlag;
          this.pointsMax = pointRes.points;
          this.orderTotal = total;
          this.promotionPrice = res.result.promotionReduce
            ? res.result.promotionReduce
            : 0;
          this.freight = freight;
          this.commodityList = [];
          let tempNeedCheck = false;
          goodsInfo.map((item) => {
            let normList = JSON.parse(item.itemTitle);
            let normDesc = "";
            for (let key in normList) {
              normDesc += `,${normList[key]}`;
            }
            normDesc = normDesc.substring(1);
            if (item.quantity > item.localStorage) {
              tempNeedCheck = true;
            }
            let noStock = "";
            if (item.quantity > item.localStorage + item.defaultStorage) {
              noStock = "库存不足";
            }
            this.commodityList.push({
              id: item.goodsId,
              skuId: item.itemId,
              shoppingCartId: item.shoppingCartId,
              storeId: item.warehouseId,
              img: item.pic
                ? item.pic
                : "http://image.8844it.com/ydb2/goodDefault.png",
              name: item.goodsName,
              normDesc,
              radio: ["1"],
              unitPrice: item.itemPrice,
              amount: item.quantity,
              localStorage: item.localStorage,
              defaultStorage: item.defaultStorage,
              localStorageCopy: item.localStorage,
              defaultStorageCopy: item.defaultStorage,
              tempNeedCheck: tempNeedCheck,
              noStock: noStock,
              subtotal: (
                Number(item.itemPrice) * Number(item.quantity)
              ).toFixed(2),
            });
          });
          if (setMealInfos.length > 0) {
            this.isSetMeal = 1;
          }
          setMealInfos.map((val) => {
            val.setMealGoodsList.map((i) => {
              let obj = {};
              obj.packageId = val.id;
              obj.setMealNum = val.setMealNum;
              let normList = JSON.parse(i.itemTitle);
              let normDesc = "";
              for (let key in normList) {
                normDesc += `,${normList[key]}`;
              }
              normDesc = normDesc.substring(1);
              let tempNeedCheck = false;
              if (i.quantity > i.localStorage) {
                tempNeedCheck = true;
              }
              let noStock = "";
              if (i.quantity > i.localStorage + i.defaultStorage) {
                noStock = "库存不足";
              }
              (obj.id = i.goodsId),
                (obj.skuId = i.itemId),
                (obj.shoppingCartId = i.shoppingCartId);
              obj.img = i.pic
                ? i.pic
                : "http://image.8844it.com/ydb2/goodDefault.png";
              obj.name = i.goodsName;
              (obj.unitPrice = i.itemPrice), (obj.radio = ["1"]);
              obj.amount = i.quantity;
              obj.localStorage = i.localStorage;
              obj.defaultStorage = i.defaultStorage;
              obj.localStorageCopy = i.localStorage;
              obj.defaultStorageCopy = i.defaultStorage;
              obj.tempNeedCheck = tempNeedCheck;
              obj.noStock = noStock;
              obj.storeId = i.warehouseId;
              obj.normDesc = normDesc;
              obj.subtotal = (Number(i.itemPrice) * Number(i.quantity)).toFixed(
                2
              );
              this.commodityList.push(obj);
            });
          });
          this.couponList = [];
          couponRes.map((coupon) => {
            this.couponList.push({
              value: coupon.id,
              label: `省${coupon.faceValue}元：${coupon.title}`,
              faceValue: coupon.faceValue,
            });
          });
          this.couponList.unshift({
            value: 0,
            label: "不使用优惠券",
            faceValue: 0,
          });
          if (!this.commodityList.length) {
            // 这个时候提交按钮无法使用
            this.allowToSubmitOrder = false;
          }
          // }
          this._getXbShippingAddressList();
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    // 前往商品详情页
    goToProduct(id) {
      let routeUrl = this.$router.resolve({
        path: "/product",
        query: {
          id: id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    // 现在积分只可输入正整数或0
    inputIntegralValue(val) {
      let num = val.toString().match(/^\d*/g)
        ? val === "00"
          ? "0"
          : val.toString().match(/^\d*/g)[0]
        : "";
      if (num > this.pointsMax) {
        if ((Number(this.pointsMax) * 0.1).toFixed(1) > this.orderTotal) {
          this.times = this.orderTotal * 10;
        } else {
          this.times = this.pointsMax;
        }
      } else {
        if ((Number(this.times) * 0.1).toFixed(1) > this.orderTotal) {
          this.times = this.orderTotal * 10;
        } else {
          this.times = num;
        }
      }
      this.integralValue = (Number(this.times) * 0.1).toFixed(1);
    },
    // 批量同意
    handleCheckAllAgreeChange(val) {
      if (val) {
        this.unpackingList.map(i => {
          i.radio = ['1']
        })
      } else {
        this.unpackingList.map(i => {
          i.radio = []
        })
      }
      this.checkAllReject = false
      this.isIndeterminate = false;
    },
    // 批量拒绝
    handleCheckAllRejectChange(val) {
      if (val) {
        this.unpackingList.map(i => {
          i.radio = ['0']
        })
      } else {
        this.unpackingList.map(i => {
          i.radio = []
        })
      }
      this.checkAllAgree = false
      this.isIndeterminate = false;
    },
    handleCheckChange(row, val) {
      row.radio = [val[val.length-1]]
      this.checkAllAgree = this.unpackingList.every((item) =>{return item.radio[0] == '1'})
      this.checkAllReject = this.unpackingList.every((item) =>{return item.radio[0] == '0'})
    }
  },
  created() {
    this.moduleStorage = getXBBasicInformation().moduleStorage;
    this._getDBAddressMock();
    // this._getXbShippingAddressList();
    if (this.$route.query.moreOrder) {
      this.logoTitle = "再来一单";
    } else {
      this.logoTitle = "订单确认";
    }
    let data;
    if (this.$route.query.packageId) {
      // 套餐下单
      this.orderType = orderTypes.packageType;
      this.isSelect = 0;
      data = {
        setMealId: Number(this.$route.query.packageId),
        setMealNum: Number(this.$route.query.setMealNum),
      };
    } else if (this.$route.query.selectedShopCartIds) {
      // 商品下单
      this.orderType = orderTypes.goodType;
      this.isSelect = 0;
      data = {
        idShoppingCartList: JSON.parse(this.$route.query.selectedShopCartIds),
      };
    } else if (this.$route.query.sample) {
      // 样品下单
      this.orderType = orderTypes.goodType;
      this.isSelect = 1;
      data = this.$route.query.sample;
    }
    this._confirmOrder(data);
  },
  components: {
    PageHeader,
    LogoHeader,
    PageFooter,
    AddressCard,
  },
};
</script>

<style lang="scss" scoped>
.confirm-order {
  position: relative;
  min-height: 100vh;
  .w126 {
    width: 126px !important;
  }
  .page-header-container {
    width: 1200px;
    margin: 0 auto;
  }
  .page-content-container {
    box-sizing: border-box;
    width: 1200px;
    min-height: 10px;
    margin: 0 auto;
    background: #fff;
    padding-bottom: 260px;
    .order-content {
      box-sizing: border-box;
      padding: 0 20px 40px 20px;
      width: 100%;
      border: 1px solid #e3e3e3;
      .address-desc-container {
        display: flex;
        align-items: center;
        height: 60px;
        .desc {
          font-size: 16px;
          color: #606266;
        }
        .add-address-btn {
          margin-left: 20px;
          font-size: 14px;
          color: #3d74f2;
          cursor: pointer;
        }
      }
      .address-list {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        overflow: hidden;
        &.hide-more-address {
          max-height: 152px;
        }
      }
      .tip {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 152px;
        border: 1px solid #e3e3e3e3;
      }
      .show-more-address {
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .desc {
          font-size: 12px;
          margin-left: 6px;
        }
        .icon {
          width: 12px;
          height: 12px;
          background-size: 12px 12px;
        }
        .up {
          background-image: url("../../../assets/secondary-menu/up.png");
        }
        .down {
          background-image: url("../../../assets/secondary-menu/down.png");
        }
      }
      .commodity-desc {
        box-sizing: border-box;
        font-size: 16px;
        display: flex;
        padding-top: 8px;
        align-items: flex-start;
        justify-content: space-between;
        height: 48px;
      }
      .setMeal-tags {
        height: 14px;
        font-size: 12px;
        line-height: 14px;
        border-radius: 2px;
        padding: 2px;
        margin-right: 6px;
        margin-top: 4px;
        color: #df3445;
        border: 1px solid #df3445;
      }
      .delivery {
        font-size: 14px;
        cursor: pointer;
      }
      .deliver-goods {
        margin-top: 16px;
        .delivery {
          display: flex;
        }
        .desc {
          width: 84px;
          text-align: right;
        }
        .default {
          color: #999;
        }
      }
      .table-container {
        border: 1px solid #e4e4e4;
        .img-desc-container {
          display: flex;
          align-items: center;
          .commodity-desc {
            font-size: 14px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding-left: 32px;
            padding-right: 40px;
            cursor: pointer;
          }
          .commodity-desc:hover {
            color: #df3445;
          }
          .localStorage-sign {
            display: inline-block;
            background: #df3445;
            color: #fff;
            font-size: 10px;
            height: 20px;
            line-height: 20px;
            border-radius: 4px;
            width: 44px;
            margin-left: 8px;
            text-align: center;
          }
        }
        .subtotal {
          color: #df3445;
        }
      }
      .coupon-list {
        margin-top: 20px;
        display: flex;
        align-items: center;
        .desc {
          font-size: 14px;
        }
        .gray {
          width: 320px;
        }
      }
      .integral-thisTime {
        margin-top: 20px;
        display: flex;
        align-items: center;
        .desc {
          width: 84px;
          font-size: 14px;
          text-align: right;
          padding-right: 9px;
          box-sizing: border-box;
        }
        .thisTime {
          width: 200px;
          margin-right: 10px;
        }
        .point-deduction {
          font-size: 14px;
          font-weight: 400;
          color: #606266;
          .point-deduction-amount {
            color: #e46573;
          }
        }
      }
      .buyer-message {
        margin-top: 20px;
        display: flex;
        .desc {
          width: 84px;
          font-size: 14px;
          text-align: right;
        }
        .message {
          width: 380px;
        }
      }
    }
    .summary-container {
      box-sizing: border-box;
      padding: 15px 0;
      display: flex;
      justify-content: flex-end;
      .summary {
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 14px;
        color: #606266;
        .amount-total {
          display: flex;
          .left {
            .desc {
              margin-left: 10px;
            }
          }
          .num {
            width: 86px;
            display: flex;
            padding-left: 36px;
            justify-content: flex-start;
            align-items: center;
          }
        }
        .promotion,
        .discount,
        .freight {
          display: flex;
          justify-content: flex-end;
          .symble {
            padding-left: 22px;
          }
          .additionSymble {
            padding-left: 19px;
          }
          .num {
            width: 86px;
            padding-left: 8px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }
          .additionNum {
            padding-left: 6px;
          }
        }
        .promotion {
          margin-top: 10px;
        }
        .discount {
          margin-top: 10px;
        }
        .freight {
          margin-top: 10px;
        }
      }
    }
    .operation {
      height: 40px;
      background: #f5f7fa;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .payable-amount {
        font-size: 16px;
        color: #606266;
        .amount {
          color: #df3445;
        }
      }
      .confirm-btn {
        margin-left: 74px;
        box-sizing: border-box;
        border: none;
        width: 100px;
        height: 40px;
        font-size: 16px;
        color: #fff;
        background: rgba(223, 52, 69, 0.75);
        &:hover {
          background: rgba(223, 52, 69, 1);
        }
        &.not-allow-submit {
          pointer-events: none;
          background: #ccc;
        }
      }
    }
  }
  .page-footer-container {
    position: absolute;
    bottom: 0;
    height: 240px;
    width: 100%;
  }
  .amount-num {
    font-size: 14px;
    font-weight: 400;
    color: #9a9a9a;
  }
  .normDesc {
    font-size: 12px;
  }
}
</style>

<style lang="scss">
#confirmOrder {
  .el-table {
    .el-table__header-wrapper {
      .el-table__header {
        .has-gutter {
          tr {
            th {
              color: #606266;
              background: #f5f7fa;
            }
          }
        }
      }
    }
  }
  .el-dialog__wrapper {
    .el-dialog {
      width: 440px;
      .el-dialog__header {
      }
      .el-dialog__body {
        .el-form {
          .el-form-item {
            margin-bottom: 20px;
            &:last-child {
              margin-bottom: 0;
            }
            .el-input {
              .el-input__inner {
                width: 300px;
              }
            }
            .el-cascader {
              .el-input {
                .el-input__suffix {
                  right: 0px;
                }
              }
            }
          }
        }
      }
      .el-dialog__footer {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        .btn {
          width: 96px;
          height: 32px;
          border-radius: 4px;
        }
        .cancel-btn {
          margin-right: 24px;
        }
        .save-btn {
          color: #ffffff;
          background: rgba(61, 116, 242, 1);
        }
      }
    }
  }
  .delivery-dialog {
    .el-table {
      border: 1px solid #eee;
      border-bottom: none;
      td,
      th {
        padding: 5px 0px;
      }
    }
    .agree-checked {
      margin-right: 60px;
    }
    .delivery-title {
      font-size: 14px;
      font-weight: 400;
      color: #606266;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      .mark {
        margin-right: 5px;
        padding-top: 5px;
      }
      .text {
        line-height: 24px;
      }
      img {
        width: 16px;
        height: 16px;
      }
    }
    .el-dialog {
      width: 520px;
      border-radius: 8px;
    }
    .el-dialog__header {
      border-bottom: 1px solid #eee;
      padding: 11px 20px;
      .el-dialog__title {
        font-size: 16px;
        font-weight: bold;
        color: #666666;
      }
      .el-dialog__headerbtn {
        top: 15px;
      }
    }
    .el-dialog__body {
      padding: 20px 35px 32px 35px;
    }
    .el-dialog__footer {
      padding: 10px;
      border-top: 1px solid #eee;
      .btn {
        width: 60px;
        height: 24px;
        border-radius: 4px;
      }
      .cancel-btn {
        margin-right: 24px;
        border: 1px solid #df3446;
        color: #df3445;
      }
      .confirm-btn {
        color: #ffffff;
        background: #df3445;
      }
    }
  }
}
</style>
